module.exports = __webpack_public_path__ + "static/media/react-512.90552fc5.png";